export default __webpack_public_path__ + "static/media/china_flag.76fb125b.png";